import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './IndustryPage.css';
import DashboardLayout from '../Dashboard/layout';
import Swal from 'sweetalert2';
import {  useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const EditIndustryPage = () => {
  const { industryId } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    status: ''
  });
const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIndustryData = async () => {
      
    //console.log("industryId222222===>>>", industryId);
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/admin/industries/${industryId}`);
        setFormData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching industry data:', error);
        setError('Failed to fetch industry data.');
        setLoading(false);
      }
    };

    fetchIndustryData();
  }, [industryId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      name: String(formData.name).trim(),
      status: String(formData.status)
    };
  
    try {
      setLoading(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}api/admin/industries/${industryId}`, payload);
      console.log('Industry updated successfully:', response.data);
      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Industry updated successfully!',
      });
      navigate("/industries");
    } catch (error) {
      console.error('Error updating industry:', error);
      setError('Failed to update industry.');
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update industry. Please try again later.',
      });
    }
  };

  return (
    <DashboardLayout>

      <section className="MainDivSec">
        <Headings headspan="Edit" hedtext=" Industry" />

        <div className="AdduserFormDiv">

          {error && <p className="error-message">{error}</p>}
          {loading ? (
            <p className="Loadingpara">Loading...</p>
          ) : (
            <Form onSubmit={handleSubmit}>

              <div className="FormGroupDiv">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter industry name"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="name">Status:</label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required >
                  <option value="">Select status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

             

              <div className="SubMit">
                <button type="submit" disabled={loading}>
                  Update Industry
                </button>
              </div>



            </Form>
          )}
        </div>

      </section>


    </DashboardLayout>
  );
};

export default EditIndustryPage;
